import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BreadcrumbsCustom from 'src/components/common/BreadcrumbsCustom';
import Edit from 'src/components/settings/time/Edit';
import { getAPI, postAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';

const UserEdit = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const timeid = searchParams.get('id');
  const doctorid = searchParams.get('doctorid');
  const token = getToken();
  const [data, setData] = useState(null);
  const [dataDoctors, setDataDoctors] = useState([]);

  const getUser = () => {
    try {
      getAPI(
        `/master/time-view?token=${token}${timeid ? `&id=${timeid}` : ''}`
      ).then((res) => {
        if (res && res.code === 200) {
          setData(res.data);
        } else {
          navigate('/master/time');
        }
      });

      postAPI(`/master/time-search?token=${token}`, {
        doctorid: doctorid || null,
        status: 1,
        page: 1,
        pagesize: 10,
      })
        .then((res: any) => {
          if (res.code === 200 && res.data) {
            setDataDoctors(res.data.items);
          }
        })
        .finally(() => {});
    } catch (error) {
      navigate('/master/time');
      console.error('Failed to fetch data:', error);
      return;
    }
  };

  useEffect(() => {
    getUser();
    // eslint-disable-next-line
  }, []);
  return (
    <>
      <BreadcrumbsCustom
        breadcrumbs={[
          {
            to: '/master/time',
            label: '予約可能時間設定',
          },
          {
            label: timeid ? '時間枠編集' : '新規時間枠',
          },
        ]}
      />
      <Typography
        fontSize={'20px'}
        fontWeight={500}
        color={'primary.dark'}
        mt={'18px'}
        mb={'16px'}
      >
        {timeid ? '時間枠編集' : '新規時間枠'}
      </Typography>
      <Stack direction={'row'} spacing={'20px'} width={'auto'}>
        <Edit
          data={data}
          dataDoctors={dataDoctors}
          timeid={timeid}
          doctorid={doctorid}
        />
      </Stack>
    </>
  );
};

export default UserEdit;
